import { render, staticRenderFns } from "./dormTeacherView.vue?vue&type=template&id=0bf119dd&scoped=true&"
import script from "./dormTeacherView.vue?vue&type=script&lang=js&"
export * from "./dormTeacherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf119dd",
  null
  
)

export default component.exports